export default "__VITE_ASSET__CwYuGiaM__"